/* eslint-disable */

export const isEmpty = value =>
  value === undefined || value === null || value === '';
